import React, { Fragment } from 'react';
import './Details.css';
var Details = function (props) {
    var fields = props.fields, value = props.value, _a = props.boldLabels, boldLabels = _a === void 0 ? false : _a, _b = props.boldValues, boldValues = _b === void 0 ? false : _b, _c = props.hover, hover = _c === void 0 ? true : _c, className = props.className;
    var buildClassName = function (basicClass, isBold) {
        return basicClass + " " + (isBold ? 'avenir-demi' : '');
    };
    var buildHoverClassName = function () { return (hover ? 'details-row-hover' : ''); };
    var renderField = function (field) {
        if (field == null)
            return null;
        return (React.createElement("tr", { key: field.name, className: buildHoverClassName() },
            React.createElement("th", { className: buildClassName('details-label', boldLabels) },
                field.heading,
                ":"),
            React.createElement("td", { className: buildClassName('details-value', boldValues) }, field.formatter
                ? field.formatter(value[field.name])
                : value[field.name])));
    };
    var renderSubfields = function (field) {
        var _a;
        return ((_a = field === null || field === void 0 ? void 0 : field.subfields) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement(Fragment, { key: field.name },
            React.createElement("tr", { key: field.name },
                React.createElement("th", { className: "details-label" },
                    React.createElement("h3", { className: "m-0" + (boldLabels ? ' avenir-demi' : '') }, field.heading))),
            field.subfields.map(function (subfield) { return (React.createElement("tr", { key: subfield.name, className: buildHoverClassName() },
                React.createElement("th", { className: buildClassName('details-label', boldLabels) },
                    subfield.heading,
                    ":"),
                React.createElement("td", { className: buildClassName('details-value', boldValues) }, subfield.formatter
                    ? subfield.formatter(value[subfield.name])
                    : value[subfield.name]))); }))) : null;
    };
    return (React.createElement("table", { className: "sattributegrid" + (className ? " " + className : '') },
        React.createElement("tbody", null, fields &&
            fields.map(function (field) {
                return field && field.subfields
                    ? renderSubfields(field)
                    : renderField(field);
            }))));
};
export default React.memo(Details);
